export default __webpack_public_path__ + "static/media/touchOne.9927c36c.svg";